import 'antd/dist/antd.css';

import * as React from 'react';
import {Suspense} from 'react';
import {UserPropsBean, DashboardReportBean} from './api/base/api';
import NotSecuredLayout from './layouts/NotSecuredLayout';
import AppProps from './util/AppProps';
import {isAuthenticated} from './util/AuthUtil';
import {advAccountApi} from './views/account/AdvAccountApi';
import {UserPropsGate} from './layouts/UserPropsGate';
import TimezoneEnum = UserPropsBean.TimezoneEnum;

const securedLayoutImport = import('./layouts/SecuredLayout');
const SecuredLayout = React.lazy(() => securedLayoutImport.catch(() => import('./layouts/SecuredLayout')));

let currentDate = new Date();
let initialDate = currentDate.toISOString().split('T')[0];

class App extends React.Component<AppProps, any> {

    state = {
        user: {
            name: '',
            logo: '',
            cTypeSwitchEnabled: false,
            advReportType: UserPropsBean.AdvReportTypeEnum.Ua,
            bundleToChannel: {},
            userTimezone: 'UTC',
            timezoneIsDst: false,
            viewOnly: true,
            bundlesWithTags: [],
            haveAudiencesWithControlGroup: false,
            showActualSpend: false,
            campaignTags: {},
            bundles: [],
            isSkanReport: false,
            haveIosBundle: false,
            allowDataUpload: false,
            advertiserId: undefined,
            currency: UserPropsBean.CurrencyEnum.USD,
            showIntegrationsPage: false,
            adMarkupType: undefined,
            showCpcAndCpm: false
        },
        filters: {
            selectedStartDate: initialDate,
            selectedEndDate: initialDate,
            datePickerStart: initialDate,
            datePickerEnd: initialDate,
            selectedOsType: undefined,
            selectedCreativeFilters: undefined,
            selectedDateRange: {dateRange: 'Last7Days', startDate: undefined, endDate: undefined},
            customDate: false,
            selectedCountry: undefined,
            bundles: [],
            countries: [],
            creativeGroupBy: undefined,
            overviewGroupBy: [DashboardReportBean.GroupByEnum.DashboardOffsetDay],
            advertiserOptions: undefined
        },
        loggedInUser: false,
        userPropsVersion: 0
    };

    firstLoadingDone = () => {
        this.setState({
            loggedInUser: true
        });
    }

    firstLoadingCancel = () => {
        this.setState({
            loggedInUser: false
        });
    }

    toggleSwitchValue = () => {
        let newValue = this.state.user.advReportType == UserPropsBean.AdvReportTypeEnum.Ua ? UserPropsBean.AdvReportTypeEnum.Rt : UserPropsBean.AdvReportTypeEnum.Ua;
        // don't change report type if dashboard opened for advertiser entity
        (this.state.user.advertiserId ? Promise.resolve() : advAccountApi.updateDefaultReportType(UserPropsBean.AdvReportTypeEnum[newValue])).then(() => {
            this.setState({
                ...this.state,
                user: {
                    ...this.state.user,
                    advReportType: newValue,
                    isSkanReport: false
                }
            });
        });
    }

    toggleSkanReport = () => {
        this.setState({
            ...this.state,
            user: {
                ...this.state.user,
                isSkanReport: !this.state.user.isSkanReport
            }
        });
    }

    updateTimezoneValue = (value: TimezoneEnum) => {
        // don't change timezone if dashboard opened for advertiser entity
        (this.state.user.advertiserId ? Promise.resolve() : advAccountApi.updateTimezone(TimezoneEnum[value])).then(() => {
            this.setState({
                ...this.state,
                user: {
                    ...this.state.user,
                    userTimezone: TimezoneEnum[value]
                }
            });
        });
    }

    setUser = (name, logo, cTypeSwitchEnabled, advReportType, bundleToChannel, userTimeZone, timezoneIsDst, viewOnly, bundlesWithTags, haveAudiencesWithControlGroup, showActualSpend, campaignTags, bundles, isSkanReport, haveIosBundle, allowDataUpload, advertiserId, funnel, currency, showIntegrationsPage, adMarkupType, showCpcAndCpm) => {
        this.setState(prevState => ({
            userPropsVersion: prevState.userPropsVersion + 1,
            user: {
                name: name,
                logo: logo,
                cTypeSwitchEnabled: cTypeSwitchEnabled,
                advReportType: advReportType,
                bundleToChannel,
                userTimezone: userTimeZone,
                timezoneIsDst: timezoneIsDst,
                viewOnly: viewOnly,
                bundlesWithTags: bundlesWithTags,
                haveAudiencesWithControlGroup: haveAudiencesWithControlGroup,
                showActualSpend: showActualSpend,
                campaignTags: campaignTags,
                bundles: bundles,
                isSkanReport: isSkanReport,
                haveIosBundle: haveIosBundle,
                allowDataUpload: allowDataUpload,
                advertiserId: advertiserId,
                funnel,
                currency,
                showIntegrationsPage,
                adMarkupType,
                showCpcAndCpm
            }
        }));
    }

    render() {
        let isNotShadowLogin = !this.props.location.pathname.includes('shadow-login');
        return isNotShadowLogin && isAuthenticated() ?
            <Suspense fallback={<></>}>
                <UserPropsGate setUser={this.setUser} filters={this.state.filters}
                               userPropsVersion={this.state.userPropsVersion}>
                    <SecuredLayout {...this.props} {...this.state}
                                   toggleSwitchValue={this.toggleSwitchValue}
                                   updateTimezoneValue={this.updateTimezoneValue}
                                   setUser={this.setUser}
                                   firstLoadingDone={this.firstLoadingDone}
                                   firstLoadingCancel={this.firstLoadingCancel}
                                   toggleSkanSwitchValue={this.toggleSkanReport}
                    />
                </UserPropsGate>
            </Suspense> :
            <Suspense fallback={<></>}>
                <NotSecuredLayout {...this.props} {...this.state} setUser={this.setUser}/>
            </Suspense>;
    }
}

export default App;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App.tsx